import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { DynamicFormComponent } from './dynamic-form/dynamic-form.component';
import { PhoneInputComponent } from './phone-input/phone-input.component';
import { BookingCartComponent } from './booking-cart/booking-cart.component';
import { BookingServiceCardComponent } from './booking-service-card/booking-service-card.component';

@NgModule({
  declarations: [
    PhoneInputComponent,
    DynamicFormComponent,
    BookingCartComponent,
    BookingServiceCardComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    NgxMatSelectSearchModule,
  ],
  exports: [
    PhoneInputComponent,
    DynamicFormComponent,
    BookingCartComponent,
    BookingServiceCardComponent,
  ],
})
export class SharedModule {}
